import {
    SET_CANDIDATELIST,
    SET_CONTESTLIST,
    SET_YEARLIST,
    SET_ELECTIONLIST,
    SET_ELECTION,
    SET_ERROR,
    SET_CONTEST,
    SET_CANDIDATESTATEMENTINFO,
    CLEAR_YEARLIST,
    CLEAR_ELECTIONLIST,
    CLEAR_CONTESTLIST,
    CLEAR_CONTEST,
    SET_YEAR,
    SET_CONTEST_BY_CANDIDATE,
    SET_LANGUAGE_CODE,
    SET_SEARCH_INPUT
} from './mutations.type';

export const mutations = {
    [SET_YEARLIST](state, yearList) {
        state.yearList = yearList;
    },
    [SET_ELECTIONLIST](state, electionList) {
        state.electionList = electionList;
    },
    [SET_ELECTION](state, electionId) {
        state.election = state.electionList.find(e => e.electionId === electionId);
    },
    [SET_CONTESTLIST](state, contestList) {
        state.contestList = contestList;
        if (contestList.length === 0) {
            state.contest = null;
        }
    },
    [SET_ERROR](state, error) {
        state.error = error;
    },
    [SET_CANDIDATELIST](state, candidateList) {
        state.candidateList = candidateList
    },
    [SET_CONTEST](state, contest, contestId) {
        state.contest = contest;
        state.selectedContest = contestId;
    },
    [SET_CANDIDATESTATEMENTINFO](state, payload) {
        state.candidateStatementInfo = payload;
    },
    [CLEAR_YEARLIST](state) {
        state.yearList = [];
    },
    [CLEAR_ELECTIONLIST](state) {
        state.electionList = [];
    },
    [CLEAR_CONTESTLIST](state) {
        state.contestlist = [];
    },
    [CLEAR_CONTEST](state) {
        state.contest = null;
    },
    [SET_YEAR](state, year) {
        state.year = year;
    },
    [SET_CONTEST_BY_CANDIDATE](state, candidate) {
        const contest = state.contestList.find(c => c.contestId === candidate.contestId && c.electionId === candidate.electionId);
        state.contest = contest;
    },
    [SET_LANGUAGE_CODE](state, language) {
        state.candidateStatementInfo.selectedLanguage = language;
    },
    [SET_SEARCH_INPUT](state, input) {
        state.search = input;
    }
}